import React, { Suspense, lazy } from "react";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Sentry } from "./lib/sentry";

const SeatingChart = lazy(() => import("./components/SeatingChart"));
const SpreadsheetTable = lazy(() => import("./components/SpreadsheetTable"));
const EventNotFound = lazy(() => import("./components/EventNotFound"));
const EventIdEntry = lazy(() => import("./components/EventIdEntry"));

const ErrorFallback = () => (
  <div className="min-h-screen bg-gray-100 flex items-center justify-center">
    <div className="text-lg text-gray-600">Something went wrong. Please refresh the page.</div>
  </div>
);

const Footer = () => (
  <footer className="py-4 text-center text-sm text-gray-500">
    Created with{" "}
    <a
      href="https://geteventi.app"
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-500 hover:underline"
      onClick={(e) => {
        e.preventDefault();
        window.open("https://geteventi.app", "_blank", "noopener,noreferrer");
      }}
    >
      Eventi
    </a>
  </footer>
);

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<ErrorFallback />}>
      <BrowserRouter>
        <Suspense fallback={<div className="min-h-screen bg-gray-100 flex items-center justify-center"><div className="text-lg text-gray-600">Loading...</div></div>}>
          <Routes>
            <Route path="/" element={<div className="min-h-screen">
              <EventIdEntry />
              <Footer />
            </div>}/>
            <Route path="/event/:event_id" element={<div className="min-h-screen bg-gray-100">
              <SeatingChart />
              <Footer />
            </div>}/>
            <Route path="/event/:event_id/edit" element={<div className="min-h-screen bg-gray-100">
              <SpreadsheetTable />
              <Footer />
            </div>}/>
            <Route path="/event-not-found" element={<div className="min-h-screen bg-gray-100">
              <EventNotFound />
              <Footer />
            </div>}/>
            <Route path="*" element={<Navigate to="/" replace />}/>
          </Routes>
        </Suspense>
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  );
}

export default App;
